(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('userImage', ['AppConfig', 'AdministrationService', '$rootScope', UserImageFn]);

    /* directive for displaying user image from cache */
    function UserImageFn(AppConfig, AdministrationService, $rootScope) {
        var directive = {
            link: link,
            restrict: 'E',
            replace: true,
            scope: {
                userId: '=',
                useDefaultImage: '@?',
                useOriginal: '@?', // use original fullsize image instead of thumbnail image
                thumbWidth: '@?', // width for thumbnail image
                thumbHeight: '@?', // height for thumbnail image,
                addQuery: '@?' // add query to url
            },
            template: '<img height="auto" width="{{::width}}" ng-src="{{url}}" />'
        };
        return directive;

        function link(scope) {
            activate();

            scope.$watch('userId', function(newValue, oldValue) {
                if (newValue !== oldValue)
                {
                    activate();
                }
            });

            //activate
            function activate() {
                // set to 0 if undefined to be able to call api
                if (typeof scope.userId === 'undefined') {
                    scope.userId = 0;
                }

                // width
                scope.width = scope.thumbWidth ? scope.thumbWidth : '100%';

                let url = "";
                if (scope.useDefaultImage ==="true")
                {
                    url = "/assets/img/no-image.png";
                }else{
                    url = AppConfig.ApiUrl + '/api/images/users/' + btoa(scope.userId) + '/' + (scope.useOriginal ? scope.useOriginal : false);
                    url += '?thumbWidth=' + (scope.thumbWidth ? scope.thumbWidth : '');
                    url += '&thumbHeight=' + (scope.thumbHeight ? scope.thumbHeight : '');
                    url += '&r=' + Math.round(Math.random() * 999999);
                }
                scope.url = url;
            }
        }// link
    }

})();